import ApiClient from './ApiClient';

class OrdersAPI extends ApiClient 
{
    constructor() {
        super('orders', { accountScoped: true });
    }

    get(params) {
        return axios.get(`${this.url}`, {
            params
        });
    }

    getPelanggan(params) {
        return axios.get(`${this.url}/list`, {
            params
        })
    }
    
    getPaket(params) {
        return axios.get(`${this.url}/packages`, {
            params
        })
    }
}


export default new OrdersAPI()